// extracted by mini-css-extract-plugin
module.exports = {"root":"Suggestions_root__p--BL","element":"Suggestions_element__9DBJd"};